import { injectShoutcastStreams, transformMislabelledHlsStreams, } from '../../../transforms/streams';
import { toHttps } from '../../../transforms/utils';
import { getMediaFormat } from '../utils';
export function transformUnwrappedStreams({ streams, forceHttpsStreams }) {
    return streams
        .map(({ url, reliability, playlistType, mediaType, streamId }) => ({
        url: forceHttpsStreams ? toHttps(url) : url,
        reliability,
        format: getMediaFormat(playlistType, mediaType),
        id: `e${streamId}`,
        wasManuallyUpgradedToHttps: Boolean(forceHttpsStreams && url?.startsWith('http://')),
    }))
        .map(transformMislabelledHlsStreams)
        .reduce(injectShoutcastStreams, []);
}
